import styled from "styled-components";
import ANIMATIONS from "../../../../resources/utils/styles/OtherCss";

export const UsersListContainer = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
  ${ANIMATIONS.basicpageAnimation}
`;
